import {
  FETCH_ORGANIZATION_EVENTS_FOR_BOOKING_FAILURE,
  FETCH_ORGANIZATION_EVENTS_FOR_BOOKING_REQUEST,
  FETCH_ORGANIZATION_EVENTS_FOR_BOOKING_SUCCESS,
  OrganizationEventsForBookingActionTypes,
  OrganizationEventsForBookingState,
} from "./types";

/**
 * The initial state for the organization events available for booking
 * @type {OrganizationEventsForBookingState}
 * @property {OrganizationEventsForBookingData[]} organizationsForBookingData - The events data
 * @property {boolean} isLoading - The loading state
 */
export const initialOrganizationEventsForBookingState: OrganizationEventsForBookingState =
  {
    events: [],
    isLoading: false,
    organizationEventsForBookingLoaded: false,
    error: null,
  };

/**
 * The organization booking events reducer.
 * @param {OrganizationEventsForBookingState} state - The organization events booking state
 * @param {OrganizationEventsForBookingActionTypes} action - The action to perform
 * @returns {OrganizationEventsForBookingState}
 */
export function organizationEventsForBookingReducer(
  state = initialOrganizationEventsForBookingState,
  action: OrganizationEventsForBookingActionTypes
): OrganizationEventsForBookingState {
  switch (action.type) {
    case FETCH_ORGANIZATION_EVENTS_FOR_BOOKING_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_ORGANIZATION_EVENTS_FOR_BOOKING_SUCCESS:
      return {
        ...state,
        isLoading: false,
        events: action.events,
        error: null,
      };
    case FETCH_ORGANIZATION_EVENTS_FOR_BOOKING_FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
}
